import { render, staticRenderFns } from "./PaymentShipperRetur.vue?vue&type=template&id=a297309e&scoped=true"
import script from "./PaymentShipperRetur.vue?vue&type=script&lang=js"
export * from "./PaymentShipperRetur.vue?vue&type=script&lang=js"
import style0 from "./PaymentShipperRetur.vue?vue&type=style&index=0&id=a297309e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a297309e",
  null
  
)

export default component.exports